const PATTERNS = [
  /%(?:\d+\$)?[@dsf]/g, // %@ %d %s %f %1$@ %1$d
  /\{[a-zA-Z_][a-zA-Z0-9_]*\}/g, // ICU {count}
];

export function extractPlaceholders(s: string): string[] {
  const found: string[] = [];
  for (const re of PATTERNS) {
    const m = s.match(re);
    if (m) found.push(...m);
  }
  return found;
}

export function missingPlaceholders(source: string, target: string): string[] {
  const src = extractPlaceholders(source);
  const tgt = new Set(extractPlaceholders(target));
  return src.filter((p) => !tgt.has(p));
}
